import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { MenuList, MenuItem, Paper } from "@mui/material";
import ContextMenu from "../ContextMenu/ContextMenu";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import { getNewRecordName } from "./ContextActions/NewRecord";
import { DATA_TYPE } from "../../constants/datatypes";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey } from "../../utils/utilFunctions";
import CopyAndPaste from "./ContextActions/CopyAndPaste";


function BlankCSVMenu(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const type = useSelector((state) => state.treeData[parentScreen].leftTree.tree.body.selectedNode?.type);
  const { tree, currentTab } = useSelector((state) => state.treeData[parentScreen].rightTree);
  const templateHeader = useSelector((state) => state.treeData[parentScreen].rightTree.tree.templateHeader);
  const { rightTree, leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const {isCopied, setIsCopied, obJSON} = props;

  function newRecordHandler() {

    // Finding Latest Key in
    const getNewRecordData = () => {

      const rightTreeChildrenArray = tree.body.translatedData[0]?.children;
      const title = getNewRecordName(tree);

      //If it is empty so it will make first node with 'ib-0' key
      if (!rightTreeChildrenArray?.length) return { key: 'ib-0-0', title }

      const lastRecordKey = rightTreeChildrenArray[rightTreeChildrenArray.length - 1].key.split('-');
      lastRecordKey[lastRecordKey.length - 1] = Number(rightTreeChildrenArray.length);
      const newRecordKey = lastRecordKey.join('-');

      return { key: newRecordKey, title };
    }

    // Creating new Record in Redux
    const nodeDetail = currentTab === "body" && parentScreen === 'inbound' ? getNewRecordData() : parentScreen === 'inbound' ? { key: "ib-0", title: getNewRecordName(tree)} : {key:{header: "obh-0", body: "ob-0", trailer: "obt-0"}[currentTab], title: `${t('LBL_RECORD')}${t('UNNAMED')}`};
    const titleType = currentTab.charAt(0).toUpperCase() + currentTab.substr(1).toLowerCase();
    const title = nodeDetail.title + (currentTab !== 'body' && parentScreen === 'inbound' ? `_${titleType}` : "")
    const newNode = {
      nodeId:genKey(nodeDetail.title),
      key: nodeDetail.key,
      title: title,
      ...(parentScreen === 'inbound' ? { TYPE: title } : {}),
      ICON_DISPLAY: (parentScreen === 'outbound' && templateHeader?.FILETYPE === 'DATABASE') ? 'RECORD_LOOP' :   DATA_TYPE[templateHeader.FILETYPE]?.record?.type,
      type: DATA_TYPE[templateHeader.FILETYPE]?.record?.icon,
      treeType: tree.currentTab,
      children: [],
      ...(parentScreen === 'outbound' ? { DESCRIPTION: 'UNNAMED' } : {}),
      ...DATA_TYPE[templateHeader.FILETYPE]?.record?.data
    };
    if (parentScreen === "outbound") {
      newNode["EDIT_RULE"] = [
        {
          "TYPE": "RECORD_RULE"
        }
      ];
      newNode["LOOP"] = "SINGLE";
      if(templateHeader?.FILETYPE === "XML"){
        newNode.FILE_TYPE = "STATIC"
        // newNode.XML_RECORD = "TRUE"
        newNode.EMPTY_ACTION = "EMPTY"
      }
    }

    dispatch(treeActions.setNewNode({ screen: parentScreen, type: currentTab, data: newNode }));
    dispatch(treeActions.setRightTreeSelectedNode({ screen: parentScreen, type: currentTab, data: newNode }));
  }

  const showMenuOrNot = useMemo(() => {
    //Checking if template is Empty or Not.
    const isTemplateEmpty =
      currentTab === "body" && parentScreen === 'inbound'
        ? tree[currentTab]?.translatedData[0]?.children?.length === 0 ||
        tree[currentTab].selectedNode?.ICON_DISPLAY === "TEMPLATE_BODY_DOTS"
        : tree[currentTab]?.translatedData?.length === 0;

    //Checking if body node is Selected or not;
    const nodeSelected =
      currentTab === "body" && parentScreen === 'inbound'
        ? Object.keys(tree[currentTab]?.selectedNode||{}).length > 0
        : true;
    return isTemplateEmpty && nodeSelected;

  }, [tree[currentTab]?.translatedData, tree[currentTab].selectedNode, tree])


  return (
    <>
      {["inboundTemplate", "outboundTemplate", "workflow"].includes(type) &&
        showMenuOrNot &&
        !Array.isArray(templateHeader) &&
        DATA_TYPE[templateHeader.FILETYPE] ? (
        <ContextMenu targetId={props.targetId}>
          <Paper elevation={3} sx={{ width: "19rem" }}>
            <MenuList>
              <MenuItem name={obJSON ? t("MNU_NEW_OBJECT") : t("MNU_NEW_REC")} onClick={newRecordHandler}>
                <span className={"RECORD"}></span>
                <span className={"margin-left-8"}>{obJSON ? t("MNU_NEW_OBJECT") : t("MNU_NEW_REC")}</span>
              </MenuItem>
              {isCopied?.copiedNodes?.length ? <MenuItem name={t("MNU_PASTE")} onClick={() => setIsCopied({ ...isCopied, paste: true,dispatchFrom:'BlankMenu',treeType:parentScreen })}>
                  <span className={"DOCUMENT"}></span>
                  <span className={"margin-left-8"}>{t("MNU_PASTE")}</span>
              </MenuItem> : ''}
            </MenuList>
          </Paper>
        </ContextMenu>
      ) : (
        ""
      )}
      <CopyAndPaste isCopied={isCopied} setIsCopied={setIsCopied} contextMenuType={isCopied?.dispatchFrom === "keyPress" ? isCopied?.dispatchFrom : "BlankMenu"} treeType={parentScreen}/>
    </>
  );
}

export default BlankCSVMenu;
